import React, { useState, useEffect } from "react";
import PolyProps from "./PolyPropss"; // Matches existing file name
import pp from "../../assets/pp.png";
import pc1 from "../../assets/pc1.png";
import pc2 from "../../assets/pc2.png";
import flagPakistan from "../../assets/pakistan.png";
import flagJapan from "../../assets/japan.png";
import flagSaudiArabia from "../../assets/saudi_arabia.png";
import flagNorway from "../../assets/norway.png";
import flagUAE from "../../assets/united_arab_emirates.png";
import flagUSA from "../../assets/united_states_of_america.png";
import s1age4 from "../../assets/s1age4.png";
import s1age7 from "../../assets/s1age7.png";
import s1age11 from "../../assets/s1age11.png";
import s2age4 from "../../assets/s2age4.png";
import s2age7 from "../../assets/s2age7.png";
import s2age11 from "../../assets/s2age11.png";
// import s3age4 from "../../assets/s3age4.png";
// import s3age7 from "../../assets/s3age7.png";
// import s3age11 from "../../assets/s3age11.png";
import sampleVideo from "../../assets/sample1.mp4";
import axios from 'axios';

const Islamic = () => {
  const [competitionData, setCompetitionData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch competition data from database
  useEffect(() => {
    const fetchCompetitionData = async () => {
      try {
        const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/allpolymatchcompetition`);
        if (response.data && response.data.length > 0) {
          // Filter competitions that contain "islamic" in the name (case insensitive)
          const islamicCompetitions = response.data.filter(comp => 
            comp.Competition_Name && comp.Competition_Name.toLowerCase().includes('islamic')
          );
          setCompetitionData(islamicCompetitions);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching competition data:', error);
        setLoading(false);
      }
    };

    fetchCompetitionData();
  }, []);

  const headerSection = {
    mainHeading: "Islamic Knowledge Competition",
    // subHeading: "2025 and 2024",
    mainImage: pp,
    leftImage: pc1,
    rightImage: pc2,
  };

  const upcomingCompetitionSection = {
    mainHeading: "For Our Upcoming Competition ",
    subHeading: "Stay Tuned",
    competitionName: "Islamic Knowledge Competition",
    description:
      "The PolyMatch Islamic Knowledge Competition ignites curiosity and celebrates the richness of Islamic teachings from around the world. This exciting event brings together brilliant minds to explore concepts in Quranic studies, Hadith, Islamic history, and beyond. Encouraging spiritual growth, critical thinking, and cultural discovery, participants deepen their understanding while building meaningful global connections in a dynamic and inspiring atmosphere",
    registerLink: "/PolymatchReg",
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  // Dynamic competition years section based on database data
  const competitionYearsSection = {
    mainHeading: "Islamic Knowledge Competition",
    defaultYear: 2024,
    years: competitionData.map(comp => ({
      year: new Date(comp.Competition_date).getFullYear(),
      title: comp.Competition_Name,
      dates: new Date(comp.Competition_date).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }),
      description: comp.Competition_Description || "The PolyMatch Islamic Knowledge Competition was a huge success, with a big rise in global participation. It was a fun, high-energy event where participants showcased their amazing knowledge of Islamic teachings and passion for learning.",
      competitionId: comp.Competition_Id,
    })),
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  const winnersSection = {
    mainHeading: "Congratulations to All Winners!",
    description:
      "We're proud of every participant, and we applaud the outstanding winners who showcased exceptional skills, creativity, and determination. Your hard work truly shines—well done!",
    winners: [
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/islamic knowledge/4 to 5/1stPosition-IsaiahGill.png",
        alt: "Age 4-5 Winner",
        ageCategory: "Ages 4-5",
        studentsData: [
          {
            name: "Ismail Farhan",
            rank: "1st Winner",
            country: "Lahore, Pakistan",
            age: "6 Years",
            image: 'Polymath-images/Winners Pics/2025/islamic knowledge/4 to 6/1stPosition-IsmailFarhan.png',
          },
          {
            name: "Muhammad Yaseen",
            rank: "2nd Winner",
            country: "Lahore, Pakistan",
            age: "6 Years",
            image: 'Polymath-images/Winners Pics/2025/islamic knowledge/4 to 6/2ndPosition-MuhammadYaseen.png',
          },
          {
            name: "Taqi Malik",
            rank: "3rd Winner",
            country: "Jubail, Saudi Arabia",
            age: "5 Years",
            image: 'Polymath-images/Winners Pics/2025/islamic knowledge/4 to 6/3rdPosition-TaqiMalik.png',
          },
        ],
      },
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/islamic knowledge/4 to 5/1stPosition-IsaiahGill.png",
        alt: "Age 6-8 Winner",
        ageCategory: "Ages 6-8",
        studentsData: [
          {
            name: "Fatima Arsalan",
            rank: "1st Winner",
            country: "Karachi, Pakistan",
            age: "8 Years",
            image: "Polymath-images/Winners Pics/2025/islamic knowledge/7 to 10/1stPosition-FatimaArsalan.png",
          },
          {
            name: "Ayat Zahid Ali",
            rank: "2nd Winner",
            country: "Hyderabad, Pakistan",
            age: "7 Years",
            image: "Polymath-images/Winners Pics/2025/islamic knowledge/7 to 10/2ndPosition-AyatZahidAli.png",
          },
          {
            name: "Hafsa Ammar",
            rank: "3rd Winner",
            country: "Karachi, Pakistan",
            age: "8 Years",
            image: "Polymath-images/Winners Pics/2025/islamic knowledge/7 to 10/3rdPosition-HafsaAmmar.png",
          },
        ],
      },
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/islamic knowledge/4 to 5/1stPosition-IsaiahGill.png",
        alt: "Age 9-11 Winner",
        ageCategory: "Ages 9-11",
        studentsData: [
          {
            name: "Zayeed Hameed",
            rank: "1st Winner",
            country: "Lahore, Pakistan",
            age: "11 Years",
            image: "Polymath-images/Winners Pics/2025/islamic knowledge/11 to 15/1stPosition-ZayeedHameed.png",
          },
          {
            name: "Amna Waseem",
            rank: "2nd Winner",
            country: "Islamabad, Pakistan",
            age: "12 Years",
            image: "Polymath-images/Winners Pics/2025/islamic knowledge/11 to 15/2ndPosition-AmnaWaseem.png",
          },
          {
            name: "Arsh Farooq",
            rank: "3rd Winner",
            country: "Karachi, Pakistan",
            age: "13 Years",
            image: "Polymath-images/Winners Pics/2025/islamic knowledge/11 to 15/3rdPosition-ArshFarooq.png",
          },
        ],
      },
      // {
      //   year: 2025,
      //   image: "Polymath-images/Winners Pics/2025/islamic knowledge/4 to 5/1stPosition-IsaiahGill.png",
      //   alt: "Age 12-15 Winner",
      //   ageCategory: "Ages 12-15",
      //   studentsData: [
      //     {
      //       name: "Hassan Raza",
      //       rank: "1st Winner",
      //       country: "Tokyo, Japan",
      //       age: "13 Years",
      //       image: "Polymath-images/Winners Pics/2025/islamic knowledge/4 to 5/1stPosition-IsaiahGill.png",
      //     },
      //     {
      //       name: "Mariam Khan",
      //       rank: "2nd Winner",
      //       country: "New York, USA",
      //       age: "14 Years",
      //     },
      //     {
      //       name: "Yusuf Ali",
      //       rank: "3rd Winner",
      //       country: "Karachi, Pakistan",
      //       age: "12 Years",
      //     },
      //   ],
      // },
    ],
    resultsLink: "/PolymatchResults_Linguistic",
  };

  const spotlightSection = {
    mainHeading: "Participant Spotlight",
    subHeading: " – Watch Them in Action",
    description:
      "Get inspired by the creativity, confidence, and talent of our young competitors. These videos showcase real moments from PolyMatch participants sharing their experiences, exploring Islamic knowledge, and celebrating success.",
    participants: [
      {
        name: "Emaan Omar",
        compName: "Islamic Knowledge Competition 2024",
        rank: "3rd Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: sampleVideo,
      },
      {
        name: "Emaan Omar",
        compName: "Islamic Knowledge Competition 2024",
        rank: "3rd Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: null,
      },
      {
        name: "Emaan Omar",
        compName: "Islamic Knowledge Competition 2024",
        rank: "3rd Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: null,
      },
      {
        name: "Emaan Omar",
        compName: "Islamic Knowledge Competition 2024",
        rank: "3rd Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: null,
      },
      {
        name: "Emaan Omar",
        compName: "Islamic Knowledge Competition 2024",
        rank: "3rd Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: null,
      },
      {
        name: "Emaan Omar",
        compName: "Islamic Knowledge Competition 2024",
        rank: "3rd Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: null,
      },
    ],
  };

  // Show loading state while fetching data
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading competition data...
      </div>
    );
  }

  // Show message if no Islamic competitions found
  if (!competitionData || competitionData.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div>
          <h3>No Islamic competitions found</h3>
          <p>Please check back later for upcoming Islamic competitions.</p>
        </div>
      </div>
    );
  }

  return (
    <PolyProps
      headerSection={headerSection}
      upcomingCompetitionSection={upcomingCompetitionSection}
      competitionYearsSection={competitionYearsSection}
      winnersSection={winnersSection}
      spotlightSection={spotlightSection}
      text={"Upcoming Event: Ramadan"}
    />
  );
};

export default Islamic;